import React from "react";
import '../Styles/MissionPage3.scss';
// import {Link} from "react-router-dom";

function MissionPage3() {

   return (
      <div className="missionPage3Content">
         <div className="missionPage3Container">
         <div className='missionflexStuff'>
            <div className="missionPage3Row1">
               <div className="controlled">
                  Controlled
               </div>
            </div>
            <div className="missionPage3Row2">
               <div className="atmosphere">
                  Atmosphere
               </div>
               <div className="forThe">
                  for the 
               </div>
            </div>
            <div className="missionPage3Row3">
               <div className="ministry">
                  Ministry
               </div>
               <div className="of">
                  of
               </div>
            </div>
            <div className="missionPage3Row4">
               <div className="ministry">
                  Preaching
               </div>
            </div>

            </div>
            <div className='missionPage3Description'>
               Camp Connect's number <br></br>
               one  goal is for  all <br></br> 
               campers to be  helped <br></br> 
               by  revival preaching <br></br> 
               and     intentionally <br></br> 
               seeks to    provide a <br></br> 
               controlled atmosphere. <br></br> 
               The  daily   schedule, <br></br> 
               and   activities   all <br></br> 
               contribute to creating <br></br> 
               an atmosphere  for God <br></br> 
               to   speak   and   for <br></br> 
               lives  to  be  changed <br></br> 
            </div>
         </div>
      </div>
   )
}
export default MissionPage3; 
